import styles from '../../styles.module.css'
import { PointOfViewButton } from './pointOfViewButton'
import { useEffect } from 'react'
import { useAppStore } from '../../shared/store/store'
import { AddPointOfViewButton } from './addPointOfViewButton'
import { RemovePointOfViewButton } from './removePointOfViewButton'
import { usePointOfViewLogic } from '../hooks/usePointOfViewLogic'

export default function PointOfViewButtonsList(): JSX.Element {
  const pointsOfView = useAppStore((state) => state.pointsOfView)
  const cameraController = useAppStore((state) => state.cameraController)
  const isGUIEnabled = useAppStore((state) => state.isGUIEnabled)
  const currentPointOfViewIndx = useAppStore((state) => state.currentPointOfViewIndx)
  const setCurrentPointOfViewIndx = useAppStore((state) => state.setCurrentPointOfViewIndx)

  useEffect(() => {
    if (isGUIEnabled) return
    cameraController?.addOnStart(() => {
      setCurrentPointOfViewIndx(-1)
    })
  }, [cameraController])

  usePointOfViewLogic()

  return (
    <div className={`${styles.point_of_interest_list} view_points`}>
      {pointsOfView.length > 1 &&
        pointsOfView.map((pointOfInterest, index) => (
          <div className={styles.point_of_interest_button_wrap} key={index}>
            <PointOfViewButton
              onClick={() => {
                setCurrentPointOfViewIndx(index)
              }}
              data={pointOfInterest}
              isSelected={index === currentPointOfViewIndx}
            />
            {isGUIEnabled && <RemovePointOfViewButton point={pointOfInterest} />}
          </div>
        ))}
      {isGUIEnabled && <AddPointOfViewButton />}
    </div>
  )
}
